<div class="page-content page-fill">
  @if (dataLoaded) {
    <div class="card mb-3">
      @if (!validated) {
        <div class="card-body">
          <h2>{{message}}</h2>
        </div>
      }
      @if (validated) {
        <div class="card-body">
          @if (filter) {
            <dx-form [formData]="filter" style="max-width: 400px">
              <dxi-item dataField="givingYear" [label]="{ text: 'Giving Year' }" editorType="dxSelectBox" [editorOptions]="{ items: givingYears }"></dxi-item>
              <dxi-item dataField="code" [label]="{ text: 'Member Code' }"></dxi-item>
              <dxi-item dataField="budgetBox" [label]="{ text: 'Budget Envelope' }"></dxi-item>
              <dxi-item dataField="email" [label]="{ text: 'Email Address' }"></dxi-item>
              <dxi-item dataField="birthDate" [label]="{ text: 'Birth Date' }" editorType="dxDateBox"></dxi-item>
            </dx-form>
          }
          <button (click)="getStatement()" class="mt-3 btn btn-danger" [disabled]="processing">Get Statement</button>
          <!-- <button (click)="getStatement(true)" class="mt-3 ms-4 btn btn-primary" [disabled]="processing">Get User Code</button> -->
          <div class="m-3">
            <h2>Last Cleared Deposit: {{ this.givingInfo?.lastDeposit }}</h2>
            <h2></h2>
            <h2>Notes:</h2>
            <ul>
              <li>The giving statement will be emailed if the entered email exists in ARK and matches the given birthday and budget envelope.</li>
              <li>Only contributions that have been deposited and cleared by the bank will show on the giving statement.</li>
              <!-- <li>The last deposit was {{this.givingInfo?.lastDeposit || 'date'}}</li> -->
            </ul>
          </div>
        </div>
      }
    </div>
  }
</div>
